<script setup>
import { ref, computed, defineEmits, defineProps } from "vue"
import Modal from "@common/js/utils/Modal.vue"
import Scheme from "./edf-oa/TariffScheme.vue"

const props = defineProps({
  modelValue: Boolean,
  offer: {
    type: Object,
    required: false,
    default: () => {},
  },
  offers: {
    type: Array,
    required: false,
    default: () => [],
  },
  isMultiple: Boolean,
})
const emit = defineEmits(["update:modelValue"])

const open = computed({
  get() {
    return props.modelValue
  },

  set(value) {
    return emit("update:modelValue", value)
  },
})
</script>

<template>
  <Modal v-model="open" :closeable="true" size="max-w-3xl">
    <Transition
      enter-active-class="duration-300 ease-out"
      enter-from-class="transform opacity-0"
      enter-to-class="opacity-100"
      leave-active-class="duration-200 ease-in"
      leave-from-class="opacity-100"
      leave-to-class="transform opacity-0"
    >
      <div v-if="open" class="relative py-6">
        <Scheme :offers="isMultiple ? offers : [offer]" />
      </div>
    </Transition>
  </Modal>
</template>
